export default __webpack_public_path__ + "static/media/coupon_logo.90bf606e.png";